export const INIT_KRY_PREREQUISITE = 'INIT_KRY_PREREQUISITE';
export const INIT_KRY_PREREQUISITE_SUCCESS = 'INIT_KRY_PREREQUISITE_SUCCESS';
export const INIT_KRY_PREREQUISITE_FAILED = 'INIT_KRY_PREREQUISITE_FAILED';
export const LEX_EXAM_RESET_STATUS = 'LEX_EXAM_RESET_STATUS';
export const LEX_EXAM_DOWNLOAD_CERT = 'LEX_EXAM_DOWNLOAD_CERT';
export const LEX_EXAM_DOWNLOAD_CERT_SUCCESS = 'LEX_EXAM_DOWNLOAD_CERT_SUCCESS';
export const LEX_EXAM_DOWNLOAD_CERT_FAILED = 'LEX_EXAM_DOWNLOAD_CERT_FAILED';
